import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import WireTemplatesResultPanel from "./WireTemplatesResultPanel";

export default function WireTemplatesPanel() {


    function mainComponent() {
        return <WireTemplatesResultPanel/>;
    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {mainComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}